import React from 'react';
import ServiceIcon from './ServiceIcon';
import './ServiceDetailsHeader.css';

const ServiceDetailsHeader = ({ service }) => {
  return (
    <div className="service-details-header">
      <div className="service-details-icon-wrapper">
        <ServiceIcon name={service.icon} className="service-details-icon" />
      </div>
      <div className="service-details-title-wrapper">
        <h1 className="service-details-title">{service.title}</h1>
        <p className="service-details-subtitle">{service.subtitle}</p>
      </div>
    </div>
  );
};

export default ServiceDetailsHeader;

